import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as MandanteFormModel from './Mandante.model';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { Console } from '@angular/core/src/console';

import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { IfObservable } from 'rxjs/observable/IfObservable';


@Component({
    selector: 'MandanteForm',
    templateUrl: './MandanteForm.component.html'
})


export class MandanteFormComponent {
    // ~~~~~ Variables para el manejo de permisos ~~~~~ //
    public btnAgregar: boolean;
    public btnEditar: boolean;
    public btnEliminar: boolean;
    public btnConsultar: boolean;
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

    public form: FormGroup;
    public formErrors: any;

    public mandante: MandanteFormModel.MandanteModel;
    public tiposId: Array<OpcionModel>;
    public tiposPersonas: Array<OpcionModel>;
    public tiposContribuyente: Array<OpcionModel>;
    public tiposPrefijos: Array<OpcionModel>;
    public tiposIngreso: Array<OpcionModel>;

    public listaNegocios: Array<OpcionModel>;
    public departamentos: Array<OpcionModel>;
    public ciudades: Array<OpcionModel>;
    public actividadesEconomicas: Array<OpcionModel>;
    public prefijo : any;

    public cargando: boolean;
    public guardando: boolean;
    public registroTercero;
    public mensaje: string;
    public cantidadSucursales;
    public creaSucursal: boolean;

    public ocultar: boolean = false;

    constructor(private formBuilder: FormBuilder,
        private _serviciosGenerales: ServiciosGenerales,
        private snackBar: MatSnackBar,
        private _route: ActivatedRoute,
        private _router: Router,
        private confirmarEliminacionService: ConfirmarEliminacionService) {

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
        this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
        this.btnEditar = _serviciosGenerales.seguridad.isEditar();
        this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
        this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
        this.snackBar.dismiss();

        this.formErrors = {
            tipoId: {},/*  */
            ctipid: {},
            cnumid: {},
            vnombre: {},
            vapellido: {},
            vapellido2: {},
            vdireccion: {},
            departamento: {},
            ciudad: {},
            tipoPersona: {},
            tipoContribuyente: {},
            vnombrerut: {},
            npais: {},
            nporcParticipacion: {},
            dfechaCreacion: {},
            actividadEconomica: {},
            ctarifa: {},
            tiposPrefijos : {},
            prefijoNegocio : {},
            tipoIngreso:{}
        };

        
        this.tiposId = new Array();
        this.tiposPersonas = new Array();
        this.tiposContribuyente = new Array();
        this.listaNegocios = new Array();
        this.ciudades = new Array();
        this.departamentos = new Array();
        this.actividadesEconomicas = new Array();
        this.tiposPrefijos = new Array();
        this.tiposIngreso = new Array();

        this.mandante = new MandanteFormModel.MandanteModel(new MandanteFormModel.MchMandatariosId('', '', '', '', 0),
            new MandanteFormModel.DefCiudades(new MandanteFormModel.DefCiudadesId('', '','169'), ''),
            new MandanteFormModel.DefTiposdocumentos(''),
            new MandanteFormModel.DefTipospersona(''), '', '', '', '', '', 0, "", "", '',new MandanteFormModel.DefPrefijos(''),
            new MandanteFormModel.DefTiposIngreso(''));

        this.cargando = false;
        this.guardando = false;

    }

    ngOnInit() {


        //console.log("--> ", JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa);

        this._route.params.subscribe(params => {
            this.registroTercero = [{
                'cnumcont': params['cnumcont'],
                'ctipid': params['ctipid'],
                'cnumid': params['cnumid'],
                'editar' : params['atras'],
                'prefijo': params['prefijo']
            }];

            this.inicializarForm();
        }
        )



        /*Se carga la informacion de las listas*/
        this.cargarInfo();

        /*Se obtiene la informacion que viaja por parametros para cargar el tercero*/

        this.form.valueChanges.subscribe(() => {
            this.onFormValuesChanged();
        });
    }

    inicializarForm() {

        console.log(this.registroTercero[0].cnumid);
        this.form = this.formBuilder.group({
            tipoId: [{ disabled: (this.registroTercero[0].cnumid == 'a' ? false : true), value: this.mandante.id.ctipid }, Validators.required],
            cnumid: [{ disabled: (this.registroTercero[0].cnumid == 'a' ? false : true), value: this.mandante.id.cnumid }, Validators.required],
            vnombre: ['', Validators.required],
            vapellido: [''],
            vapellido2: [''],
            vdireccion: ['', Validators.required],
            departamento: ['', Validators.required],
            ciudad: ['', Validators.required],
            tipoPersona: ['', Validators.required],
            vnombrerut: ['', Validators.required],
            npais: [{ disabled: true, value: 169 }, Validators.required],
            nporcParticipacion: ['', Validators.required],
            dfechaCreacion: ['', Validators.required],
            actividadEconomica: ['', Validators.required],
            ctarifa: ['', Validators.required],
            prefijoNegocio: [{disabled: (this.registroTercero[0].cnumid == 'a' ? false : true),value: this.mandante.cprefijo},Validators.required],
            tipoIngreso:['',Validators.required]
        });
    }


    cargarInfo() {

        this._serviciosGenerales.get('tipoIdentificacion', {}).subscribe(result => {
            for (let x of result) {
                this.tiposId.push(new OpcionModel(x.ctipid, x.vdescripcion));
            }
            this._serviciosGenerales.get('tipoPersona', { param: 0 }).subscribe(result => {
                for (let x of result) {
                    this.tiposPersonas.push(new OpcionModel(x.ntipper, x.vdescripcion));
                }
               
                        this._serviciosGenerales.get('departamentos', { param: 0 }).subscribe(result => {
                        for (let x of result) {
                            this.departamentos.push(new OpcionModel(x.ccodigodepto, x.vnombre));
                        }
                        if (this.registroTercero[0].ctipid != ' ' && this.registroTercero[0].cnumid != ' ') {
                            this.cargarInformacionMandante();
                            this.mensaje = "Editar";
                        } else {
                            this.mensaje = "Crear";
                            this.mandante.id.cnumcont = this.registroTercero[0].cnumcont;
                        }

                },
                    error => {
                        var errorMensaje = <any>error;
                        console.log('Error al enviar la peticion ', errorMensaje);
                        this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos departamentos", "X");
                    }
                );
            },
                error => {
                    var errorMensaje = <any>error;
                    console.log('Error al enviar la peticion ', errorMensaje);
                    this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de persona", "X");

                });
        },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de identificación", "X");
            });

        this._serviciosGenerales.get('listadoActividadesEconomicas', { param: 0 }).subscribe(result => {
            for (let x of result) {
                this.actividadesEconomicas.push(new OpcionModel(x.CCODACTI, x.VDESCRIPCION));
            }
        },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos departamentos", "X");
            });

            this._serviciosGenerales.get('listadoTipoIngreso', { param: 0 }).subscribe(result => {
                for (let x of result) {
                    this.tiposIngreso.push(new OpcionModel(x.ntipoingreso, x.vdescripcion));
                }
            },
                error => {
                    var errorMensaje = <any>error;
                    console.log('Error al enviar la peticion ', errorMensaje);
                    this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos departamentos", "X");
                });




        this._serviciosGenerales.get('prefijosNegocio', { cnumcont :this.registroTercero[0].cnumcont  }).subscribe(result => {
            for (let x of result) {
                this.tiposPrefijos.push(new OpcionModel(x.cprefijo,x.cprefijo));
             }
             console.log('Michael ',this.tiposPrefijos); 
        },

            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos departamentos", "X");
            });
    }

    consultarCiudades(id: string) {
        this.ciudades = new Array();
        this._serviciosGenerales.get('ciudades', { ccodigodepto: this.mandante.defCiudades.id.ccodigodepto }).subscribe(
            result => {
                for (let x of result) {
                    this.ciudades.push(new OpcionModel(x.ccodigociudad.toString(), x.vnombre));
                }
                setTimeout(() => {
                    if (id != '-1') {
                        this.mandante.defCiudades.id.ccodigociudad = id;
                    }
                }, 100)
            },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
            }
        );
    }



    private cargarInformacionMandante() {
        this.mandante = new MandanteFormModel.MandanteModel(new MandanteFormModel.MchMandatariosId('', '', '', '', 0),
            new MandanteFormModel.DefCiudades(new MandanteFormModel.DefCiudadesId('', '','169'), ''),
            new MandanteFormModel.DefTiposdocumentos(''),
            new MandanteFormModel.DefTipospersona(''), '', '', '', '', '', 0, '', '', '',new MandanteFormModel.DefPrefijos(''),
            new MandanteFormModel.DefTiposIngreso(''));


        this._serviciosGenerales.get('mandantes', { cnumcont: this.registroTercero[0].cnumcont, cnumid: this.registroTercero[0].cnumid }).subscribe(result => {
            for (let x of result) {
                
                console.log("Michael x3====>",x.ntipoingreso);

                this.mandante = new MandanteFormModel.MandanteModel(new MandanteFormModel.MchMandatariosId(this.registroTercero[0].cnumcont, x.ctipid, x.cnumid, this.registroTercero[0].cnumcont, 0),
                    new MandanteFormModel.DefCiudades(new MandanteFormModel.DefCiudadesId('', x.ccodigodepto,'169'), ""),
                    new MandanteFormModel.DefTiposdocumentos(x.ctipid),
                    new MandanteFormModel.DefTipospersona(x.ntipper), x.vnombre, x.vapellido, x.vapellido2, x.vdireccion, x.vnombrerut, x.nporc_participacion,
                    new Date(x.dfecha_creacion).toISOString(), x.ccodacti, x.ctarifa,(x.cprefijo),
                    new MandanteFormModel.DefTiposIngreso(x.ntipoingreso));
                
                    this.consultarCiudades(x.ccodigociudad);

                
console.log(this.mandante);
            }
        },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("Ocurrió un error al momento de cargar el tercero", "X");
            });
    }


    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 20000
        });
    }


    onFormValuesChanged() {
        for (const field in this.formErrors) {
            if (!this.formErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.formErrors[field] = {};

            // Get the control
            const control = this.form.get(field);

            if (control && control.dirty && !control.valid) {
                this.formErrors[field] = control.errors;
            }
        }
    }


    guardar() {
        this.mandante.nporcParticipacion=100
        if (this.form.valid == false) {
            this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
            return;
        }
        if (this.mandante.nporcParticipacion > 100) {
            this.openSnackBarEspecial('El valor del campo (Porcentaje Participación) no puede ser Mayor a cien(100)', 'X');
            return;
        }
        if (this.mandante.nporcParticipacion < 0) {
            this.openSnackBarEspecial('El valor del campo (Porcentaje Participación) no puede ser Menor a cero(0)', 'X');
            return;
        }
        if (this.mandante.defTipospersona.ntipper == '1' && this.mandante.vapellido.replace(' ', '') == '') {
            this.openSnackBarEspecial('Cuando el Tipo de Persona es NATURAL el campo Primer Apellido debe estar diligenciado', 'X');
            return;
        }

        /*         if(this.mandante.defTiposdocumentos.ctipid != '02' && this.mandante.defTiposdocumentos.ctipid != '07' && this.mandante.defTiposdocumentos.ctipid != '08'){
                    if(this.mandante.vapellido.trim() == ''){
                        this.openSnackBar('El primer apellido es requerido', 'X');
                        return;		
                    }
                } */


        this.guardando = true;
        //this.tercero.paramNegocios.id.cnumcont = this.tercero.id.cnumcont;
        /*         this.mandante.id.ctipid = this.mandante.defTiposdocumentos.ctipid;
         */

        this.mandante.id.ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa;
        this.mandante.id.ccodigoContrato = this.registroTercero[0].cnumcont;
        this.mandante.id.cnumcont = this.registroTercero[0].cnumcont;
        this.mandante.defTiposdocumentos.ctipid = this.mandante.id.ctipid;


        this._serviciosGenerales.get('validarSumaPorcentajeMandatarios', { cnumcont: this.registroTercero[0].cnumcont, prefijo: this.mandante.cprefijo, cnumid: this.mandante.id.cnumid  }).subscribe(
            result => {
            
                var valorSumaPorcentajes = result[0];
                console.log ("Michael 123333333  = ",valorSumaPorcentajes);
                if (valorSumaPorcentajes == undefined){
                    valorSumaPorcentajes = 0;
                    }
                else{
                    var valorSumaPorcentajes = result[0].cantidad;
                    }

                console.log ("Michael 123  = ",valorSumaPorcentajes);
                var porcentajeParticipacion = this.mandante.nporcParticipacion;
                console.log ("Michael 123456  = ",porcentajeParticipacion);
                 if(((parseFloat(valorSumaPorcentajes)+ parseFloat(porcentajeParticipacion.valueOf().toString()))>100 )){
                    this.openSnackBarEspecial('El mandante : ' + this.mandante.id.ctipid + '-' + this.mandante.id.cnumid + ' No se puede crear ya que la suma de Mandantes supera el 100% ', 'X');
                    return;
                 }
                 else {
                        this._serviciosGenerales.get('validarMandante', { cnumcont: this.registroTercero[0].cnumcont, cnumid: this.mandante.id.cnumid, ctipid: this.mandante.id.ctipid }).subscribe(
                            result => {

                                if (result[0].c > 0 && this.registroTercero[0].editar != 'e') {
                                    this.openSnackBarEspecial('El mandante : ' + this.mandante.id.ctipid + '-' + this.mandante.id.cnumid + ' ya existe en el sistema ', 'X');
                                    return;
                                } else {

                                    this._serviciosGenerales.post('guardar/mandante', this.mandante).subscribe(
                                        result => {
                                            this.openSnackBar("Proceso realizado con éxito", "X");
                                            /*
                                        this.form.reset();
                                            this.form.clearAsyncValidators();
                                            this.form.clearValidators();
                            */
                                            this.prefijo =  this.mandante.cprefijo;

                                            this.mandante = new MandanteFormModel.MandanteModel(new MandanteFormModel.MchMandatariosId('', '', '', '', 0),
                                                new MandanteFormModel.DefCiudades(new MandanteFormModel.DefCiudadesId('', '','169'), ''),
                                                new MandanteFormModel.DefTiposdocumentos(''),
                                                new MandanteFormModel.DefTipospersona(''), '', '', '', '', '', 0, '', '', '',new MandanteFormModel.DefPrefijos(''),
                                                new MandanteFormModel.DefTiposIngreso(''));

                                            this._router.navigate(['/Mandante', '', this.registroTercero[0].cnumcont,this.prefijo]);


                                            this.guardando = false;
                                            //this.cargarInformacionMandante();
                                        },
                                        error => {
                                            var errorMensaje = <any>error;
                                            console.log('Error al enviar la peticion ', errorMensaje);
                                            this.openSnackBarEspecial("Ocurrió un error al momento de guardar el mandante", "X");
                                        }
                                    )
                                }
                            }, error => {
                                var errorMensaje = <any>error;
                                console.log('Error al enviar la peticion ', errorMensaje);
                                this.openSnackBarEspecial("Ocurrió un error al momento de validar el prefijo", "X");
                                return;
                            })

                        }
                    }, error => {
                        var errorMensaje = <any>error;
                        console.log('Error al enviar la peticion ', errorMensaje);
                        this.openSnackBarEspecial("Ocurrió un error al momento de validar el prefijo", "X");
                        return;
                    })

    }


    validarRequerido() {

    }


    openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Prefijo/MandanteForm.component.ts